import paymentApi from '../../utils/paymentApi';

export async function getBillingHistory(params) {
  const response = await paymentApi.get('/billing/history', { params });
  const payload = response?.data;
  if (!payload || Number(payload.code) !== 200) {
    const error = new Error(payload?.message || '账单记录暂时无法加载');
    error.code = payload?.data?.error_code || payload?.code;
    throw error;
  }
  return payload.data;
}

export async function getCreditAccountOverview() {
  const response = await paymentApi.get('/credit-account');
  const payload = response?.data;
  if (!payload || Number(payload.code) !== 200) {
    const error = new Error(payload?.message || '点数明细暂时无法加载');
    error.code = payload?.data?.error_code || payload?.code;
    throw error;
  }
  return payload.data;
}

export async function getCreditAccountLedger(params) {
  const response = await paymentApi.get('/credit-account/ledger', { params });
  const payload = response?.data;
  if (!payload || Number(payload.code) !== 200) {
    const error = new Error(payload?.message || '点数明细暂时无法加载');
    error.code = payload?.data?.error_code || payload?.code;
    throw error;
  }
  return payload.data;
}
